import { render } from "./DisplayNameOverride.vue?vue&type=template&id=d72327a8"
import script from "./DisplayNameOverride.vue?vue&type=script&lang=js"
export * from "./DisplayNameOverride.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__